'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _NavigationItem = require('../components/NavigationItem');

var _NavigationItem2 = _interopRequireDefault(_NavigationItem);

var _propTypes3 = require('../propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigationItems: state.navigationItems
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onDelete: function onDelete() {
      dispatch((0, _actions.deleteNavigationItem)(ownProps.baseUrl, ownProps.navigationItem));
    },

    onEdit: function onEdit() {
      dispatch((0, _actions.editNavigationItem)(ownProps.navigationItem));
    },

    onExpand: function onExpand() {
      dispatch((0, _actions.toggleSectionExpanded)(ownProps.navigationItem.id));
    },

    onMoveNavigationItemInto: function onMoveNavigationItemInto(movedItem, navigationItems) {
      var newNavigationItems = navigationItems.reposition(movedItem.id, ownProps.navigationItem.id, 1);

      dispatch((0, _actions.sortNavigationItems)(ownProps.baseUrl, newNavigationItems));
    },

    onMoveNavigationItemOnto: function onMoveNavigationItemOnto(movedItem, navigationItems) {
      var myItem = ownProps.navigationItem;
      var sameSection = movedItem.navigation_section_id === myItem.navigation_section_id;
      var movingDown = sameSection && movedItem.position < myItem.position;

      var newNavigationItems = void 0;
      if (movingDown) {
        newNavigationItems = navigationItems.reposition(movedItem.id, myItem.navigation_section_id, myItem.position + 1);
      } else {
        newNavigationItems = navigationItems.reposition(movedItem.id, myItem.navigation_section_id, myItem.position);
      }

      dispatch((0, _actions.sortNavigationItems)(ownProps.baseUrl, newNavigationItems));
    }
  };
};

var EditableNavigationItem = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_NavigationItem2.default);

EditableNavigationItem.propTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  navigationItem: _propTypes3.NavigationItemPropType.isRequired
};

exports.default = EditableNavigationItem;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/containers/EditableNavigationItem.js
// module id = 209
// module chunks = 0